import React from 'react';
import c from 'classnames';
import ActionBarButton, { Props as ActionBarButtonProps } from '../ActionBarButton';
import s from './ActionBarEditButton.scss';

interface Props extends ActionBarButtonProps {}

/**
 * Provides some some alternative hover styling compared to `ActionBarButton`.
 */
const ActionBarEditButton: React.FC<Props> = ({ className, ...rest }) => {
  return <ActionBarButton className={c(s['root'], className)} {...rest} />;
};
ActionBarEditButton.displayName = 'ActionBarEditButton';

export default ActionBarEditButton;
